import { useNavigate } from 'react-router';
import browserHistory from '~/browserHistory';
import { OutlineChevronLeftIcon } from '@tempmee/react-icons';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Row } from '../Row';
import { IBackWhiteButtonProps } from './Types';

export const BackWhiteButton = ({
  whiteArrow,
  containerStyle = {},
  backRoute,
}: IBackWhiteButtonProps) => {
  const navigate = useNavigate();

  return (
    <Row
      alignItems="center"
      cursor="pointer"
      justifyContent="center"
      marginLeft={10}
      style={containerStyle}
      width="100%"
      onClick={() => (backRoute ? browserHistory.push(backRoute) : navigate(-1))}
    >
      <OutlineChevronLeftIcon
        color={whiteArrow ? colors.shades[0] : colors.secondary[500]}
        size={30}
      />
      <Typography as="span" bold color={colors.shades[0]} size="heading_4" textAlign="left" style={{ width: '100%', cursor: 'pointer' }}>
        Back
      </Typography>
    </Row>
  );
};
